(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  // Custom Newsletter form validation
  document.addEventListener('DOMContentLoaded', () =>{
    var newsletterForm = document.querySelector('.newsletter-form');
    var emailInput = newsletterForm.querySelector('input[type="email"]');
    var errorSpan = newsletterForm.querySelector('.newsletter-input-container span');
    var submitButton = newsletterForm.querySelector('button[type="submit"]');
    var privacyCheckbox = newsletterForm.querySelector('.privacy-checkbox-container input[type="checkbox"]');
    var privacyError = newsletterForm.querySelector('.privacy-error');
    var newsletterPrivacyLabel = newsletterForm.querySelector('.newsletter-privacy-label');

    submitButton.addEventListener('click', (event) => {
      if (!emailInput.value && !emailInput.value !== '') {
        event.preventDefault();
        errorSpan.style.display = 'block';
      } 
      else if(emailInput.value !== '') {
        errorSpan.style.display = 'none';
        // check if the email is valid
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(emailInput.value)) {
          event.preventDefault();
          errorSpan.style.display = 'block';
          errorSpan.textContent = 'Please enter a valid email address';
        }
      }

      if (!privacyCheckbox.checked) {
        event.preventDefault();
        privacyError.style.display = 'block';
      } else {
        privacyError.style.display = 'none';
      }
    });

    privacyCheckbox.addEventListener('change', function() {
      privacyError.style.display = 'none';

      if (!privacyCheckbox.checked) {
        newsletterForm.querySelector('.privacy-checkbox').style.background = '';
      } else {
        newsletterForm.querySelector('.privacy-checkbox').style.background = 'black';
      }
    });

    emailInput.addEventListener('input', function() {
      errorSpan.style.display = 'none';
    });

    if(isMobile) {
      // hide privacy label on mobile and submitt button until the input is selected 
      newsletterPrivacyLabel.style.display = 'none';
      submitButton.style.display = 'none';

      emailInput.addEventListener('focus', function() {
        newsletterPrivacyLabel.style.display = '';
        submitButton.style.display = '';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
